import {equals} from "ramda";

export default function equalContent(array1, array2){
	return equals(new Set(array1), new Set(array2));
}
